import {Component, ChangeDetectionStrategy, Input, forwardRef} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {Home365Utils} from "@home365/common-classes";
import {MatOptionSelectionChange} from "@angular/material/core/option/option";

interface UserSelect  {
  name: string,
  id: string,
  profileImg: string,
  numbers?: number
  selected?: boolean;
}

@Component({
  selector: 'lib-user-select',
  templateUrl: './user-select.component.html',
  styleUrls: ['./user-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UserSelectComponent),
      multi: true,
    },
  ],
})
export class UserSelectComponent implements ControlValueAccessor {
  @Input() multiSelect = true;
  @Input() firstIdToSelect = null;
  private _usersList: UserSelect[] = []
  @Input() set usersList(val: UserSelect[]) {
    if (val) {
      this.initValues(val);
      if (val.length >= this.maxUsersInView) {
          this.usersInView = val.slice(0, this.maxUsersInView);
      } else {
        this.usersInView = val;
      }
    }
  };
  get usersList() {
    return this._usersList;
  }
  @Input() maxUsersInView = 4;
  control!: FormControl;
  usersInView: UserSelect[] = []
  onChange: any = () => {}
  onTouch: any = () => {}
  constructor() {
    this.control = new FormControl();
    this.control.valueChanges.subscribe(val => this.onChange(val))
  }

  private initValues(val: UserSelect[]) {
    let usrSelectedIdx;
    const selectedUsers = this.control.value;
    this._usersList = Home365Utils.sortAlphabetically(val, 'ASC', 'name');
    if (this.firstIdToSelect) {
      // @ts-ignore
      const usrIdx = this._usersList.findIndex(el => el.id.toLowerCase() === this.firstIdToSelect.toLowerCase())
      if (usrIdx > -1) {
        this._usersList[usrIdx].selected = true;
        this.control.setValue([this._usersList[usrIdx].id], {emitEvent: false})
        const usr = this._usersList[usrIdx];
        this._usersList.splice(usrIdx, 1)
        this._usersList.unshift(usr);
      }
      if(this.control.value) {
        selectedUsers.forEach((e: string) => {
          usrSelectedIdx = this._usersList.findIndex(el => el.id.toLowerCase() === e.toLowerCase())
          if(usrSelectedIdx != -1 ) {
            this._usersList[usrSelectedIdx].selected = true;
          }
        })
      }
    }
    else if(this.control.value) {
      selectedUsers.forEach((e: string) => {
        usrSelectedIdx = this._usersList.findIndex(el => el.id.toLowerCase() === e.toLowerCase())
        if(usrSelectedIdx != -1 ) {
          this._usersList[usrSelectedIdx].selected = true;
        }
      })
    }

  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }
  }

  writeValue(obj: string[]): void {
    this.control.setValue(obj ? Array.isArray(obj) ? obj : [obj] : [])
  }

  getInitials(user: UserSelect) {
    if (!user.name) return 'N/A';
    const splitName = user.name?.trim().toUpperCase().split(' ');
    return splitName.length > 1 ? splitName[0][0] + (splitName[1][0] ? splitName[1][0]: '') : splitName[0][0]
  }

  selectUserInView(user: UserSelect) {
    user.selected = !user.selected
    const formControlValue: string[] = this.control.value;

    if (user.selected) {
      formControlValue.push(user.id);
    } else {
      const foundUserIdx = formControlValue.findIndex(e => e == user.id)
      if (foundUserIdx != -1) {
        formControlValue.splice(foundUserIdx, 1);
      }
    }

    this.control.setValue(formControlValue)

  }

  usrSelection(event: MatOptionSelectionChange) {
    if (!event.isUserInput) return;
    //need to select usr in view (the ones in the circle)
    const usrInView = this.usersInView.find(e => e.id === event.source.value)
    if (!usrInView) return;
    usrInView.selected = event.source.selected
  }
}
